import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import FileMappingWizardComponentList from "../../../scenes/data-manager/file-mapping/wizard/component-list";
import { selectELCubeComponentListComponent } from './actions';

const mapStateToProps = state => ({
  selectedCubeComponentCode: state.scenes.easyLoading.selectedCubeComponentCode,
  components: state.scenes.easyLoading.components,
  cube: state.scenes.easyLoading.cube
});

const mapDispatchToProps = dispatch => ({
  onCubeComponentSelect: cubeComponentCode => dispatch(selectELCubeComponentListComponent(cubeComponentCode)),
});

const ELCubeComponentList = ({
                              selectedCubeComponentCode,
                              components,
                              cube,
                              selectedMapping,
                              onCubeComponentSelect,
                            }) => {

  const handleCubeComponentSelect = (Code) => {
    if (selectedMapping === -1) {
      onCubeComponentSelect(Code);
    }
  }                              

  return (
    <Fragment>
      <FileMappingWizardComponentList
        components={
          cube !== null
            ? (
              [
                ...cube.components.dimensions.map(dim => ({
                  ...dim,
                  icon: 'bar-chart',
                })),
                ...cube.components.timeDimensions.map(dim => ({
                  ...dim,
                  icon: 'clock-circle'
                })),
                ...cube.components.attributes.map(attr => ({
                  ...attr,
                  icon: 'profile'
                })),
                ...cube.components.measures.map(meas => ({
                  ...meas,
                  icon: 'line-chart'
                }))
              ]
                .map((comp, idx) => ({
                  ...comp,
                  name: comp.Code,
                  key: idx,
                  onDetail: null,
                }))
            ) :
            []
        }
        selected={selectedCubeComponentCode !== null ? selectedCubeComponentCode : null}
        onSelect={({Code}) => handleCubeComponentSelect(Code)}
        disabled={components.map(comp => comp.cubeComponentCode)}          
        hasIcon={true}
      />
    </Fragment>
  )
};

export default connect(mapStateToProps, mapDispatchToProps)(ELCubeComponentList);



// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/ELCubeComponentList.jsx